<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>DANH SÁCH PHIẾU BẢO HÀNH</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataPermission.includes('CNPS_DEVICE_ORDER_WARRANTY_CREATE')"
          @click="create"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
        <button
          v-if="dataPermission.includes('CNPS_DEVICE_ORDER_WARRANTY_VIEW')"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.code"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị/Số phiếu"
              @keyup.enter="submitForm()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryName"
              :options="optionType"
              placeholder="Loại thiết bị"
            ></Select2>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.status"
              :options="Config.getSearch(Config.statusWarranty)"
              :settings="{ placeholder: 'Trạng thái phiếu' }"
            ></select2-multiple-control>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.closedDate"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian đóng phiếu
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.region" :options="optionRegion" placeholder="Vùng"></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryId"
              :options="Config.getSearch(optionInventory)"
              placeholder="Kho đang xử lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reason"
              :options="Config.getSearch(Config.faultMaker)"
              placeholder="Đối tượng gây lỗi"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <p><b>Tạo:</b> {{ data.item.createTime | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p><b>Đóng:</b> {{ data.item.closedTime | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(device)="data">
                <p v-if="data.item.deviceError">{{ data.item.deviceError.name }}</p>
                <p v-if="data.item.deviceError">{{ data.item.deviceError.serial }}</p>
                <p v-if="data.item.deviceError">
                  {{ data.item.deviceError.typeError | transformData(Config.stateDevices) }}
                </p>
              </template>
              <template #cell(inventory)="data">
                <p><b>Tạo:</b> {{ data.item.initInventoryName }}</p>
                <p><b>Đang xử lý:</b> {{ data.item.processingInventoryName }}</p>
              </template>
              <template #cell(region)="data">
                <p v-if="data.item.regionNames">{{ data.item.regionNames.join(',') }}</p>
              </template>
              <template #cell(typeError)="data">
                <p v-if="data.item.deviceError">{{ data.item.deviceError.errors.join(',') }}</p>
              </template>
              <template #cell(reason)="data">
                <p v-if="data.item.deviceError">
                  {{ data.item.deviceError.reason | transformData(Config.faultMaker) }}
                </p>
              </template>
              <template #cell(creator)="data">
                <p>{{ data.item.creator ? data.item.creator.name : '' }}</p>
              </template>
              <template #cell(type)="data">
                <p>{{ data.item.type | transformData(Config.warrantyStatus) }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge mb-1" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusWarranty) }} </span
                ><br />
                <span v-if="data.item.reasonReject"
                  >Lý do từ chối: {{ data.item.reasonReject }}</span
                >
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_DEVICE_ORDER_WARRANTY_VIEW')"
                    @click="detailWarranty(data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      checkStatusPermission(data.item.status, 'CNPS_DEVICE_ORDER_WARRANTY_CREATE')
                    "
                    @click="edit(data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      checkStatusAwaitApprove(
                        data.item.status,
                        'CNPS_DEVICE_ORDER_WARRANTY_APPROVE_REJECT'
                      )
                    "
                    @click="approveItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Duyệt
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      checkStatusWaitProgress(
                        data.item.status,
                        'CNPS_DEVICE_ORDER_WARRANTY_UPDATE'
                      ) ||
                      checkStatusInProgress(data.item.status, 'CNPS_DEVICE_ORDER_WARRANTY_UPDATE')
                    "
                    @click="$router.push(`/warranty/active/${data.item.id}`)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Ghi nhận bảo hành
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      checkStatusAwaitReceive(
                        data.item.status,
                        'CNPS_DEVICE_ORDER_WARRANTY_RECEIVE'
                      )
                    "
                    @click="sendReceiveItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Tiếp nhận
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="checkSendApprove(data.item.status, 'CNPS_DEVICE_ORDER_WARRANTY_CREATE')"
                    @click="sendApproveItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Gửi duyệt
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      checkReject(data.item.status, 'CNPS_DEVICE_ORDER_WARRANTY_APPROVE_REJECT')
                    "
                    @click="rejectItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Từ chối
                    {{ data.item.status === 'WAIT_RECEIVE' ? 'tiếp nhận' : '' }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="checkCancel(data.item.status, 'CNPS_DEVICE_ORDER_WARRANTY_CANCEL')"
                    @click="cancelItem(data.item)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Hủy
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import mxItemAction from './mx-item-action.js'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import moment from 'moment'
  import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 170px' },
    { key: 'code', label: 'Số phiếu', thStyle: 'min-width: 250px' },
    { key: 'device', label: 'Thiết bị', thStyle: 'min-width: 150px' },
    { key: 'inventory', label: 'Kho', thStyle: 'min-width: 150px' },
    { key: 'creator', label: 'Người tạo', thStyle: 'min-width: 150px' },
    { key: 'region', label: 'Vùng', thStyle: 'min-width: 150px' },
    { key: 'typeError', label: 'Loại lỗi', thStyle: 'min-width: 150px' },
    { key: 'reason', label: 'Đối tượng gây lỗi', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'warranty',
    mixins: [mxItemAction],
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        fieldsTable,
        showLoading: false,
        filterTable: fieldsTable,
        tbLoading: false,
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          limit: 20,
          page: 1,
          createdTime: { startDate: from, endDate: to },
          closedDate: {},
        },
        optionInventory: [],
        dataManager: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionType: [],
        optionRegion: [],
        hasDefaultFilter: true,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      DeviceService.infoWarehouse()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.optionInventory = s))
      DeviceService.typeDeviceConfig()
        .then(s => s.data?.map(s => ({ id: s.name, text: s.name })) ?? [])
        .then(s => (this.optionType = s))
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      StaffService.getRegions({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.optionRegion = s))
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        if (data.createdTime.endDate) {
          data.dateCreatedFrom = moment(data.createdTime.startDate).startOf('day').valueOf()
          data.dateCreatedTo = moment(data.createdTime.endDate).endOf('day').valueOf()
        }
        if (data.closedDate.endDate) {
          data.dateClosedFrom = moment(data.closedDate.startDate).startOf('day').valueOf()
          data.dateClosedTo = moment(data.closedDate.endDate).endOf('day').valueOf()
        }
        delete data.createdTime
        delete data.closedDate
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await DeviceService.getListWarranty(params)
          if (response.code === 1000) {
            this.lists = response.data.res ? response.data.res : []
            this.pagination.total = response.data.count ? response.data.count : 0
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message)
        } finally {
          this.tbLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
          closedDate: {
            startDate: null,
            endDate: null,
          },
        }
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.hasDefaultFilter = false
        this.search.createdTime = { startDate: null, endDate: null }
        this.search.page = 1
        this.fetchData()
      },
      create() {
        this.$router.push({ path: '/warranty/create' })
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          delete params.limit
          delete params.page
          this.showLoading = true
          await DeviceService.exportWarranty(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style></style>
